// extracted by mini-css-extract-plugin
module.exports = {"title":"TrainingSchool_title_32Req","video":"TrainingSchool_video_3G0Df","note":"TrainingSchool_note_3gRfZ"};